export function isValidBoolean(val) {
  return val.search(/true|false/) === 0;
}